// extracted by mini-css-extract-plugin
export default {"darkIcon":"DataFlowDetailActions_darkIcon__1Usr1","actionsContainer":"DataFlowDetailActions_actionsContainer__2XdMN"};